import { BaseQuestion } from "../BaseQuestion";

export default abstract class QuestionConverter {
  abstract convert(q: BaseQuestion): any;
}